import React, {useEffect, useState, useImperativeHandle, useRef} from "react";
import "./ExamTab.scss";
import {
  Divider,
  Space,
  Row,
  Dropdown,
  Button,
  Col,
  notification,
  Form,
  message,
  Spin,
} from "antd";
import type {MenuProps} from "antd";
import Icons from "assets/icons";
import {InputFields, ModalCustom} from "components/common";
// import AppearanceExpand from "./components/AppearanceExpand/AppearanceExpand";
// import InjuryExpand from "./components/InjuryExpand/InjuryExpand";
// import AppendAgesExpand from "./components/AppendAgesExpand/AppendAgesExpand";
// import ConjunctivaExpand from "./components/ConjunctivaExpand/ConjunctivaExpand";
// import ScleraExpand from "./components/ScleraExpand/ScleraExpand";
// import CorneaExpand from "./components/CorneaExpand/CorneaExpand";
// import AnteriorExpand from "./components/AnteriorExpand/AnteriorExpand";
// import PupilExpand from "./components/PupilExpand/PupilExpand";
// import IrisExpand from "./components/IrisExpand/IrisExpand";
// import LensExpand from "./components/LensExpand/LensExpand";
// import ExtraocularExpand from "./components/ExtraocularExpand/ExtraocularExpand";
// import IntraocularExpand from "./components/IntraocularExpand/IntraocularExpand";
// import GonioscopyExpand from "./components/GonioscopyExpand/GonioscopyExpand";
// import FundusExpand from "./components/FundusExpand/FundusExpand";
// import {fieldsExamTab} from "./ExamTab.config";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {getDiagnosticExamination} from "redux/reducer/diagnosticExamination";
import {RootState} from "redux/store";

import {examOutService, medicalExaminationService} from "api";
import {
  setButtonHeaderExam,
  setDataChanDoan,
  setForm,
  setObjectChanDoan,
} from "redux/reducer/examination";
import LeftEye from "./LeftEye/LeftEye";
import RightEye from "./RightEye/RightEye";
import Notification from "components/common/notification/notification";
import {fieldsExamTab} from "./ExamTab.config";
import NurseOutModal from "components/common/PrintReceipt/NurseOutModal/NurseOutModal";
import PrintForm from "pages/Refractive/InforDetails/PrintForm/PrintForm";
import {setIdReceiptNurseOut} from "redux/reducer/nurseOut";
import {setIdReceipt} from "redux/reducer/pending";
import {jsonParse} from "helper/common";
import {tabKeys} from "types/enums";

const ExamTab = React.forwardRef((props, ref) => {
  const refractionRef = useRef<any>();
  const nurseOutRef = useRef<any>();
  const leftRef = useRef(null);
  const rightRef = useRef(null);
  const dispatch = useAppDispatch();
  const idPK = useAppSelector(state => state.common.idPhieuKham);
  let idPKNT = useAppSelector(state => state.examination.idPKNT);
  const activeTab = useAppSelector(state => state.common.activeTab);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [idPhieuDieuDuong, setIdPhieuDieuDuong] = useState(null);
  const [idPhieuKhucXa, setIdPhieuKhucXa] = useState(null);
  const dataChanDoan = useAppSelector(state => state.examination.dataChanDoan);

  useImperativeHandle(
    ref,
    () => ({
      getChanDoanValue: () => {
        return form.getFieldsValue();
      },
      getFieldValue: namePath => {
        return form.getFieldValue(namePath);
      },
      setFieldsValue: data => {
        form.setFieldsValue(data);
      },
      setFieldValue: (namePath, value) => {
        form.setFieldValue(namePath, value);
      },
    }),
    []
  );
  // useEffect(() => {
  //   handleGetFormValue();
  // }, [data]);
  const openPrintForm = (name: "Điều Dưỡng" | "Khúc Xạ") => {
    if (name == "Điều Dưỡng") {
      dispatch(setIdReceiptNurseOut(idPhieuDieuDuong));
      nurseOutRef?.current.openModal();
    } else {
      refractionRef.current.openModal();
      dispatch(setIdReceipt(idPhieuKhucXa));
    }
  };
  const fetchHistoriesById = async () => {
    if (idPK == null) {
      // notification.error({message: "chưa có thông tin phiếu khám!"})
      return;
    }
    try {
      let listPhieu = await examOutService.getHistoriesByIdPK({
        idPhieuKham: idPK,
      });
      setIdPhieuDieuDuong(
        listPhieu?.find(e => e?.tenPhieu?.includes("Điều Dưỡng"))?.idPhieu ||
          null
      );
      setIdPhieuKhucXa(
        listPhieu?.find(e => e?.tenPhieu?.includes("Khúc Xạ"))?.idPhieu || null
      );
    } catch (err) {
      setIdPhieuDieuDuong(null);
      setIdPhieuKhucXa(null);
    }
  };
  useEffect(() => {
    if (idPK != null) {
      fetchHistoriesById();
    }
  }, [idPK]);
  useEffect(() => {
    if (activeTab == tabKeys.EXAMINATION.INFOR_DETAIL) {
      fetchChuanDoanByIdPKNT();
    }
  }, [activeTab]);
  const fetchChuanDoanByIdPKNT = async () => {
    if (idPKNT == null) {
      // notification.error({message: "Chưa có thông tin mã phiếu khám!"});
      return;
    } else {
      try {
        let res = await medicalExaminationService.getDiagnosticByIdExamination({
          id: idPKNT,
        });
        dispatch(setDataChanDoan(res));
      } catch (err) {
        dispatch(setDataChanDoan(null));
        // setTimeout(() => {
        //   fetchChuanDoanByIdPKNT();
        // }, 3000);
        notification.error({message: "Lỗi khi lấy thông tin chẩn đoán "});
      }
    }
  };
  const setChanDoanValue = dataChanDoan => {
    if (dataChanDoan?.jsonValue) {
      const data = jsonParse(dataChanDoan?.jsonValue);
      dispatch(setObjectChanDoan(data));
      form.setFieldsValue(data);
    } else {
      form.resetFields();
    }
  };
  useEffect(() => {
    if (dataChanDoan) {
      localStorage.setItem("jsonValue", dataChanDoan?.jsonValue);
      setChanDoanValue(dataChanDoan);
    }
  }, [dataChanDoan]);
  const handleGetFormValue = () => {
    // if (data) {
    //   let newData = {};
    //   newData["generalExamination"] = data.generalExamination;
    //   newData["ghiChu"] = data.ghiChu;
    //   newData["oneEyed"] = data.oneEyed;
    //   newData["squintEvaluation"] = data.squintEvaluation;
    //   newData["rightJsonValue"] = {};
    //   newData["leftJsonValue"] = {};
    //   properties.forEach((item, index) => {
    //     if (data.jsonTrai.length > index) {
    //       const jsonObjectLeft = eval(
    //         "(" + data.jsonTrai[index].jsonValue + ")"
    //       );
    //       newData["rightJsonValue"][item] = jsonObjectLeft;
    //     }
    //     if (data.jsonPhai.length > index) {
    //       const jsonObjectRight = eval(
    //         "(" + data.jsonPhai[index].jsonValue + ")"
    //       );
    //       newData["leftJsonValue"][item] = jsonObjectRight;
    //     }
    //   });
    //   setLoading(false);
    //   form.setFieldsValue(newData);
    // }
  };

  const handleFormValuesChange = (changedValues, allValues) => {
    localStorage.setItem("jsonValue", JSON.stringify(allValues));
  };
  const formValues = Form.useWatch([], form);
  useEffect(() => {
    handleFormValuesChange(null, formValues);
  }, [formValues]);
  // const Save
  const onFinish = values => {
    // setLoading(true);
    // let dataUpdate: any = {
    //   id: data?.id,
    //   idPhieuKham: examinationId,
    //   ghiChu: values.ghiChu,
    //   oneEyed: values.oneEyed,
    //   squintEvaluation: values.squintEvaluation,
    //   generalExamination: values.generalExamination,
    //   jsonTrai: [],
    //   jsonPhai: [],
    // };
    // properties.forEach((item, index) => {
    //   if (values?.rightJsonValue[item]) {
    //     dataUpdate.jsonTrai.push({
    //       id: index,
    //       idChuanDoan: 1,
    //       type: item,
    //       jsonValue: JSON.stringify(values?.rightJsonValue[item]),
    //       thuTu: index,
    //       viTri: 0,
    //     });
    //   }
    //   if (values?.leftJsonValue[item]) {
    //     dataUpdate.jsonPhai.push({
    //       id: index,
    //       idChuanDoan: 1,
    //       type: item,
    //       jsonValue: JSON.stringify(values?.leftJsonValue[item]),
    //       thuTu: index,
    //       viTri: 0,
    //     });
    //   }
    // });
    // try {
    //   setLoading(false);
    //   let response = medicalExaminationService.updateDiagnostic(
    //     dataUpdate,
    //     data.id
    //   );
    //   Notification("success", "Đã cập nhật thông tin chẩn đoán");
    // } catch (err) {
    //   setLoading(false);
    //   Notification("success", "Đã có lỗi khi thông tin chẩn đoán");
    // }
    // return false;
  };

  useEffect(() => {
    form.resetFields();
    fetchChuanDoanByIdPKNT();
  }, [idPKNT]);
  // useEffect(() => {}, [values]);
  const clearAll = () => {
    leftRef?.current?.clearAll();
    rightRef?.current?.clearAll();
  };
  return (
    <div className="exam-tab-container">
      <Spin spinning={loading}>
        <Divider />
        <Space
          className="space-exam-container"
          direction="vertical"
          size={"middle"}
        >
          <Form
            form={form}
            onFinish={onFinish}
            // onValuesChange={handleFormValuesChange}
          >
            {/* <Button onClick={getChanDoanValue}>Submit</Button> */}
            <Row>
              <Col span={18}>
                <Row gutter={[16, 8]} style={{marginBottom: "8px"}}>
                  <InputFields data={fieldsExamTab} />
                </Row>
              </Col>
              <Col
                span={6}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                  marginBottom: 8,
                  paddingRight: 12,
                }}
              >
                <div>
                  <Space style={{}}>
                    {idPhieuDieuDuong && (
                      <Button
                        onClick={() => {
                          openPrintForm("Điều Dưỡng");
                        }}
                        icon={<Icons.printer />}
                        type="primary"
                      >
                        Phiếu điều dưỡng
                      </Button>
                    )}
                    {idPhieuKhucXa && (
                      <Button
                        onClick={() => {
                          openPrintForm("Khúc Xạ");
                        }}
                        icon={<Icons.printer />}
                        type="primary"
                      >
                        Phiếu khúc xạ
                      </Button>
                    )}
                  </Space>
                </div>
              </Col>
            </Row>

            {/* <Row justify="end" style={{marginBottom: "8px", paddingRight: 12}}>
              <Button danger type="primary" onClick={clearAll}>
                Xóa triệu chứng
              </Button>
            </Row> */}
            <Row gutter={[24, 16]}>
              <Col xl={12} lg={12} sm={24} xs={24}>
                <RightEye ref={rightRef} form={form} />
              </Col>
              <Col xl={12} lg={12} sm={24} xs={24}>
                <LeftEye ref={leftRef} />
              </Col>
            </Row>
          </Form>

          {/* <Form form={form} onFinish={onFinish}>
            <Row justify={"end"}>
              <Form.Item>
                <Button
                  type="primary"
                  icon={<Icons.save  />}
                  htmlType="submit"
                >
                  Lưu lại
                </Button>
              </Form.Item>
            </Row>
          </Form> */}
        </Space>
      </Spin>
      <ModalCustom ref={nurseOutRef} width={1000} centered>
        <NurseOutModal />
      </ModalCustom>
      <ModalCustom ref={refractionRef} width={1000} centered>
        <PrintForm />
      </ModalCustom>
    </div>
  );
});

export default ExamTab;
